export enum TransactionMode {
    SINGLE = "SINGLE",
    SERIAL = "SERIAL",
    EXPRESS = "EXPRESS"
}
export enum TransactionAction {
    TRANSLATE_TEXT = "TRANSLATE_TEXT",
    GENERATE_AUDIO = "GENERATE_AUDIO",
    APPROVE_AUDIO = "APPROVE_AUDIO",
    UPLOAD_AUDIO = "UPLOAD_AUDIO"
}
